import { createSignal } from '@funtech-int/rival';

export const trailerStartPositionVar = createSignal(0);
